import React, { useState, useEffect } from 'react';
import '../styles/SplashScreen.css';

function SplashScreen({ onFinish }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // 2 saniye sonra fade out başlat
    const timer1 = setTimeout(() => {
      setFadeOut(true);
    }, 2000);

    // 2.5 saniye sonra splash'i kapat
    const timer2 = setTimeout(() => {
      onFinish();
    }, 2500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onFinish]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        {/* Logo */}
        <div className="splash-logo">
          <div className="logo-icon">
            <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Tabela ikonu */}
              <rect x="10" y="25" width="80" height="50" rx="5" fill="url(#gradient1)" />
              <rect x="15" y="30" width="70" height="40" rx="3" fill="white" fillOpacity="0.9" />
              <rect x="43" y="75" width="14" height="15" fill="url(#gradient1)" />
              <rect x="35" y="88" width="30" height="5" rx="2" fill="url(#gradient1)" />
              
              {/* Yazı efekti */}
              <text x="50" y="55" textAnchor="middle" fill="url(#gradient1)" fontSize="16" fontWeight="bold">
                ERP
              </text>
              
              <defs>
                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#667eea" />
                  <stop offset="100%" stopColor="#764ba2" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h1 className="splash-title">Ekol Tabela</h1>
          <p className="splash-subtitle">Sipariş Yönetim Sistemi</p>
        </div>

        {/* Loading animasyonu */}
        <div className="splash-loader">
          <div className="loader-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Versiyon */}
        <div className="splash-version">v1.0.0</div>
      </div>
    </div>
  );
}

export default SplashScreen;